module.exports = __webpack_public_path__ + "img/GE Aviation Digital.301c5fbc.png";